import React from "react";
import { useState, useRef, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import "react-confirm-alert/src/react-confirm-alert.css";
//import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
//import { Image, Shimmer } from "react-shimmer";removeuploads
import { BASE_PATH } from ".././../constants/Global";
import { encode } from "base-64";
import axios from "axios";
import { FaCheckCircle } from "react-icons/fa";
import { IoAlertCircleOutline } from "react-icons/io5";
import qs from "qs";

import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import {
  actlistData,
  actmore,
  catlistData,
  setisfirsttime,
} from "../../actions/index";
import dateFormat from "dateformat";
import { auctiondefaultLogo, svg } from "../../constants/Images";
import NotFound from "../include/NotFound";
import { FirebaseContext } from "../../FirebaseContext";
import { MdDeleteOutline } from "react-icons/md";
import { MdVerified } from "react-icons/md";
import { VscDebugBreakpointConditionalUnverified } from "react-icons/vsc";
import { LuBadgeAlert } from "react-icons/lu";

import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faL, faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import {
  getDatabase,
  ref,
  // remove,
  // push,
  // onValue,
  set,
  // off,
  // update,
} from "firebase/database";
import { playerlistData, teamlistData } from "../../actions/index";
import { AiOutlineClose } from "react-icons/ai";
// import { Link } from "react-router-dom";

function Auctiondetail(match) {
  const toMySQLDateTime = (date, time) => {
    if (!date || !time) return "";
    return `${date} ${time}:00`;
  };
  const [dateTimeValue, setDateTimeValue] = useState("");

  const dispatch = useDispatch();
  const loginuser = useSelector((state) => state.setUserlog);
  const getPlayerspageData = useSelector((state) => state.setplayerlistData);

  const history = useHistory({ forceRefresh: true });
  const [data, setData] = useState([]);
  const [teamdata, setTeamData] = useState([]);
  const [path, setPath] = useState(
    "https://mscsuper.blr1.digitaloceanspaces.com/auction/"
  );
  const [adata, setAData] = useState([]);
  const [pltraid, setpltraid] = useState("");
  const [tmtraid, settmtraid] = useState("");
  const [booster, setbooster] = useState("");
  const [aucback, setaucback] = useState("");
  const [aucbackbox, setaucbackbox] = useState("");
  const [aucstampbox, setaucstampbox] = useState("");
  const [aucustampbox, setaucustampbox] = useState("");
  const [aucsoldstamp, setaucsoldstamp] = useState("");
  const [aucunsoldstamp, setaucunsoldstamp] = useState("");
  const [aucmusic, setaucmusic] = useState("");
  const [aucsponsorbox, setaucsponsorbox] = useState("");
  const [aucbannerbox, setaucbannerbox] = useState("");
  const [aucsponsor, setaucsponsor] = useState("");
  const [aucbanner, setaucbanner] = useState("");
  const [plno, setplno] = useState("");
  const [istfp, setistfp] = useState(false);
  const [istft, setistft] = useState(false);
  const [iscopied, setiscopied] = useState(false);
  const [iscopied2, setiscopied2] = useState(false);
  const [isActive, setActive] = useState(false);
  const [timertyp, settimertyp] = useState("");
  const [starttime, setstarttime] = useState("");
  const [reftime, setreftime] = useState("");
  const [tempdata, settempdata] = useState("");
  const getpageData = useSelector((state) => state.setactlistData);
  const getpageData2 = useSelector((state) => state.setactlistData);
  const getTeampageData = useSelector((state) => state.setteamlistData);
  const profile = useSelector((state) => state.setUserlog);

  const [check1, setcheck1] = useState(false);
  const [isimgpop, setisimgpop] = useState(false);
  const [imgpopdata, setimgpopdata] = useState([]);
  const [aucdetail, setaucdetail] = useState([]);
  const [imgpoptype, setimgpoptype] = useState("");
  const [isbgpop, setisbgpop] = useState(false);
  // const [bnrs, setbnrs] = useState([]);
  // const [aucdetail, setaucdetail] = useState([]);
  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const aucmoredetail = useSelector((state) => state.actmoredata);
  const updtoken = useSelector((state) => state.updtoken);
  const [admin_id, setadminid] = useState(localStorage.getItem("admin_id"));

  const [cid, setCid] = useState(loginuser["cid"]);
  const [token, settoken] = useState(loginuser["token"]);
  const aid = localStorage.getItem("auction_id");
  // const [isbgpop, setisbgpop] = useState(false)
  const [bgdata, setbgdata] = useState([]);
  const [isfullbg, setisfullbg] = useState(false);
  const [bgfulldata, setbgfulldata] = useState("");
  const [selectedbgfl, setselectedbgfl] = useState("");
  const [incr, setincr] = useState("");
  const [incrafter, setincrafter] = useState("");
  const [tfmsg, settfmsg] = useState("");
  const [iscreate, setiscreate] = useState(false);
  const [to_date, setto_date] = useState("");
  const [from_date, setfrom_date] = useState("");
  const [win_point, setwin_point] = useState("");
  const [type, settype] = useState("");
  const [sname, setsname] = useState("");
  const [season, setseason] = useState("");
  const [isallreq, setisallreq] = useState("");
  const [city, setcity] = useState("");
  const [tourList, setTourList] = useState([]);
  const [trid, settrid] = useState(0);
  const [pldata, setpldata] = useState([]);
  const [catData, setcatData] = useState([]);
  const [showLimitModal, setShowLimitModal] = useState(false);
  // const [limitType, setLimitType] = useState(null);
  const [enablePlayerLimit, setEnablePlayerLimit] = useState(false);
  const [enableDateLimit, setEnableDateLimit] = useState(false);

  const [playerLimit, setPlayerLimit] = useState("");
  // const [showSetButton, setShowSetButton] = useState(false);
  const [playerLimitValue, setPlayerLimitValue] = useState("");
  const [dateLimitValue, setDateLimitValue] = useState("");
  const hideLayoutDomains = [
    "auction.inboxwoods.com",
    "webstreaming.in",
  ];
   const currentDomain = window.location.hostname;
   const hideLayout = hideLayoutDomains.includes(currentDomain);

  // const cid = 1;
  // const navigate = useNavigate();
  const fileInputRefs = useRef(
    Array.from({ length: 8 }, () => React.createRef())
  );

  const handleSetPlayers = () => {
    if (playerLimit && playerLimit > 0) {
      toast.success(`Registration limit set to ${playerLimit} players`);
      // API call ya Redux dispatch
    }
  };
  const fetchLimit = async () => {
    const aid = localStorage.getItem("auction_id");

    const payload = { aid: aid };
    const body = JSON.stringify(payload);

    const hdr = {
      headers: {
        "Content-Type": "application/json",
        authorization: JSON.stringify([
          {
            cid: loginuser["cid"],
            token: loginuser["token"],
          },
        ]),
      },
    };

    try {
      const res = await DataService.getLimit(body, hdr);

      console.log("LIMIT RESPONSE", res.data);

      if (res.data.success && res.data.data) {
        const d = res.data.data;

        setEnablePlayerLimit(!!d.is_pl_limit);
        setEnableDateLimit(!!d.is_dt_limit);

        setPlayerLimitValue(d.is_pl_limit ?? "");

        if (d.is_dt_limit) {
          const [date, time] = d.is_dt_limit.split(" ");
          setDateLimitValue(date);
          setDateTimeValue(time?.slice(0, 5));
        }
      } else {
        // toast.error(res.data.msg || "Unable to load limit");
      }
    } catch (err) {
      console.log("LIMIT FETCH ERROR:", err);
      toast.error("Server error loading limit");
    }
  };

  const saveLimitToServer = async () => {
    const aid = localStorage.getItem("auction_id");

    const payload = {
      aid: aid,
      chk_pl_limit: enablePlayerLimit ? 1 : 0,
      chk_dt_limit: enableDateLimit ? 1 : 0,
    };

    if (enablePlayerLimit && playerLimitValue) {
      payload.is_pl_limit = playerLimitValue;
    }

    if (enableDateLimit) {
      let finalDateTime = "";

      if (dateLimitValue && dateTimeValue) {
        finalDateTime = `${dateLimitValue} ${dateTimeValue}:00`;
      } else if (dateLimitValue) {
        finalDateTime = `${dateLimitValue} 23:59:59`;
      } else if (dateTimeValue) {
        const today = new Date().toISOString().slice(0, 10);
        finalDateTime = `${today} ${dateTimeValue}:00`;
      }

      if (finalDateTime) {
        payload.is_dt_limit = finalDateTime;
      }
    }

    const hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: loginuser["cid"], token: loginuser["token"], aid: aid },
        ]),
      },
    };

    try {
      const res = await DataService.saveLimit(qs.stringify(payload), hdr);
      if (res.data.success) {
        toast.success(res.data.msg || "Limit updated successfully!");
      } else {
        toast.error(res.data.msg || "Failed to update limit");
      }
    } catch (err) {
      toast.error("Server error");
      console.log(err);
    }
  };

  const firechange = (datasnap) => {
    if (datasnap.type == "1" && datasnap.upd == "2") {
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter((ele, ind) => {
          if (ele.aid == datasnap.id) {
            // //  console.log()
            ele.logo = datasnap.detail.logo;
            ele.type = datasnap.detail.type;
            ele.acttype = datasnap.detail.acttype;
            ele.dt = datasnap.detail.dt;
            ele.atm = datasnap.detail.atm;
            ele.aname = datasnap.detail.aname;
            ele.totalpoint = datasnap.detail.totalpoint;
            ele.unit = datasnap.detail.unit;
            ele.minbid = datasnap.detail.minbid;
            ele.bidup = datasnap.detail.bidup;
            ele.player = datasnap.detail.player;
            ele.minplayer = datasnap.detail.minplayer;
            ele.ses = datasnap.detail.ses;
            setAData(ele);
          }
          return ele;
        });
        localStorage.setItem("auction_name", datasnap.detail.aname);
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
    }
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter(
          (ele) => ele.aid != datasnap.id
        );

        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + "my-auction");
    }
    if (datasnap.type == "1" && datasnap.upd == "6") {
      if (datasnap.detail.typ == "1") {
        if (datasnap.detail.val == "0") {
          setcheck1(false);
        } else if (datasnap.detail.val == "1") {
          setcheck1(true);
        }
        var auccopy = aucdetail;
        auccopy = auccopy.detail.reg_player_on = datasnap.detail.val;
        setaucdetail((prev) => ({
          ...prev,
          detail: { ...prev.detail, reg_player_on: datasnap.detail.val },
        }));
        dispatch(actmore(auccopy));
      }
      if (datasnap.detail.typ == "11") {
        var updateitem = getpageData.responsedata.list.map((ele) => {
          if (ele.aid == aid) {
            ele.istimer = datasnap.detail.val.istimer;
            ele.stime = datasnap.detail.val.stime;
            ele.rftime = datasnap.detail.val.rftime;
          }
          return ele;
        });
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));

        settimertyp(datasnap.detail.val.istimer);
        setstarttime(datasnap.detail.val.stime);
        setreftime(datasnap.detail.val.rftime);
      }
      if (datasnap.detail.typ == "12") {
        var auccopy = aucdetail;

        if (datasnap.detail.upd == 1) {
          if (auccopy.boost) {
            auccopy.boost = [...auccopy.boost, datasnap.detail.val];
          } else {
            auccopy.boost = [datasnap.detail.val];
          }
          // setaucdetail((prev) => ({ ...prev, detail: { ...prev.detail, boost: [datasnap.detail.val] } }))
          dispatch(actmore(auccopy));
        } else if (datasnap.detail.upd == 2) {
          const newbooster = aucdetail.boost.filter(
            (ele) => ele.bsid !== datasnap.detail.val.id
          );
          auccopy.boost = newbooster;
          dispatch(actmore(auccopy));
        }
      }
      if (datasnap.detail.typ == "13") {
        if (datasnap.detail.up == 1) {
          var auccopy = aucdetail;
          auccopy.more[0].bg = datasnap.detail.val.img;
          setaucbackbox(auccopy.fpath + datasnap.detail.val.img);

          setaucdetail((prev) => ({
            ...prev,
            more: [{ ...prev.more, bg: datasnap.detail.val.img }],
          }));
          dispatch(actmore(auccopy));
        } else if (datasnap.detail.upd == 2) {
          setaucbackbox("");
          setaucdetail((detail) => ({
            ...detail,
            more: [{ ...detail.more[0], bg: "" }],
          }));
        }
      }
      if (datasnap.detail.typ == "14") {
        var auccopy = aucdetail;
        if (datasnap.detail.upd == 1) {
          auccopy.spn = [...auccopy.spn, datasnap.detail.val];
          dispatch(actmore(auccopy));
        } else if (datasnap.detail.upd == 2) {
          const newsponsors = aucdetail.spn.filter(
            (ele) => ele.spnid !== datasnap.detail.val.id
          );
          auccopy.spn = newsponsors;
          dispatch(actmore(auccopy));
        }
      }
      if (datasnap.detail.typ == "15") {
        var auccopy = aucdetail;
        if (datasnap.detail.upd == 1) {
          auccopy.bnr = [...auccopy.bnr, datasnap.detail.val];
          dispatch(actmore(auccopy));
        } else if (datasnap.detail.upd == 2) {
          const newbanners = aucdetail.bnr.filter(
            (ele) => ele.bnrid !== datasnap.detail.val.id
          );
          auccopy.bnr = newbanners;
          dispatch(actmore(auccopy));
        }
      }
      if (datasnap.detail.typ == "16") {
        var auccopy = adata;
        auccopy.minplayer = datasnap.detail.val.min_plr;
        auccopy.unit = datasnap.detail.val.unit;
        auccopy.isdecm = datasnap.detail.val.isdecm;
        // dispatch(actmore(auccopy));
      }
    }
  };

  const deldata = (id) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => del(id, 1),
        },
        {
          label: "No",
          onClick: () => del(id, 0),
        },
      ],
    });
  };
  const delboostdata = (id) => {
    confirmAlert({
      message: "Are you sure delete this !",
      buttons: [
        {
          label: "Yes",
          onClick: () => delbooster(id),
        },
        {
          label: "No",
        },
      ],
    });
  };
  const delincrdata = (id) => {
    confirmAlert({
      message: "Are you sure delete this !",
      buttons: [
        {
          label: "Yes",
          onClick: () => delincr(id),
        },
        {
          label: "No",
        },
      ],
    });
  };
  const delfile = (t) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => removeuploads(t),
        },
        {
          label: "No",
          // onClick: () => del(id, 0),
        },
      ],
    });
  };
  const del = useCallback(
    async (vl, status) => {
      if (status == 1) {
        setActive(true);

        var hdr = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            authorization: JSON.stringify([
              { cid: loginuser["cid"], token: loginuser["token"] },
            ]),
          },
        };

        await DataService.deleteAuction({ aid: encode(vl) }, hdr)
          .then((res) => {
            let response = res.data;
            if (response.success == true) {
              toast.success(response.msg, {
                theme: "dark",
                position: "bottom-center",
              });

              const updateitem = getpageData.responsedata.list.filter(
                (ele, ind) => {
                  if (ele.aid != vl) {
                    return ele;
                  }
                }
              );
              let responsedata = {
                responsedata: {
                  path: getpageData.responsedata.path,
                  cid: cid,
                  list: updateitem,
                },
              };
              dispatch(actlistData(responsedata));
              history.push(BASE_PATH + "my-auction");
              // const updateitem = data.list.filter((ele, ind) => {
              //   return ele.aid != vl;
              // });
              // data.list = updateitem;
              // setData(data);
            } else {
              toast.error(response.msg, {
                theme: "colored",
                position: "bottom-center",
              });
            }

            setActive(false);
          })
          .catch(() => {
            //  console.log("Not valid");
            toast.error("Not valid Server Error", {
              theme: "colored",
              position: "bottom-center",
            });
            setActive(false);
          });
      }
    },
    [data]
  );
  const fetchaucData = async () => {
    // localStorage.removeItem('auction_id')

    setActive(true);
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listAuction({ myauction: 1 }, hdr)
      .then((res) => {
        let response = res.data;
        console.log("list response");
        console.log(response);
        if (response.success == true) {
          let responsedata = response.data;
          console.log("responsedata....");
          console.log(responsedata);

          setPath(responsedata.path);
          setAData(responsedata.list.filter((ele, ind) => ele.aid == aid)[0]);
          settimertyp(
            responsedata.list.filter((ele, ind) => ele.aid == aid)[0].istimer
          );
          setstarttime(
            responsedata.list.filter((ele, ind) => ele.aid == aid)[0].stime
          );
          setreftime(
            responsedata.list.filter((ele, ind) => ele.aid == aid)[0].rftime
          );

          dispatch(actlistData({ responsedata }));
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        setActive(false);
      });
    // if (localStorage.getItem("isadel")) {
    //   //  console.log("from mapp")
    // history.push(BASE_PATH + 'auction-detail')
    // }
  };
  const fetchTeamData = async () => {
    setActive(true);

    var hdr = {
      params: {
        frm: 1,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listTeam({}, hdr)
      .then((res) => {
        let response = res.data;

        if (response.success == true) {
          let responsedata = response.data;
          setTeamData(responsedata);
          // setTeampath(responsedata.path)
          dispatch(teamlistData({ responsedata }));
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        setActive(false);
      });
  };
  const fetchPlayersData = async () => {
    // //  console.log("aiiiiiid")
    // //  console.log(aid)
    setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded", //v
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listPlayer({ self: 1 }, hdr)
      .then((res) => {
        let response = res.data;
        //  console.log('players data')
        //  console.log(response)

        if (response.success == true) {
          let responsedata = response.data;
          const sortedData = responsedata.list.sort(
            (a, b) => a.pcode - b.pcode
          );
          responsedata.list = sortedData;
          setpldata(responsedata);
          dispatch(playerlistData({ responsedata }));
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        setActive(false);
      });
  };

  const fetchcatData = async () => {
    setActive(true);
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listCategory({ aid: aid }, hdr)
      .then((res) => {
        let response = res.data;
        console.log("categories response");
        console.log(response);
        if (response.success == true) {
          let responsedata = response.data;
          setcatData(responsedata.list);
          dispatch(catlistData({ responsedata }));
        }
        setActive(false);
      })
      .catch(() => {
        console.log("Error fetching categories");
        setActive(false);
      });
  };

  const fetchdetail = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var val = {};
    // val.aid=aid;
    // val.faid = pltraid;
    await DataService.aucdetail(val, hdr)
      .then((res) => {
        let response = res.data;
        console.log("auc detail response");
        console.log(response);
        localStorage.setItem("auction_type", response.data.detail.acttype);
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          dispatch(actmore(response.data));

          if (response.data.detail.reg_player_on == 1) {
            setcheck1(true);
          }
          setaucdetail(response.data);

          if (response.data.more.length > 0) {
            localStorage.setItem("pdffont", response.data.more[0].pdffont);
            localStorage.setItem(
              "ispdfwhitebg",
              response.data.more[0].ispdfwhitebg
            );
            if (
              response.data.more[0].bg != "" &&
              response.data.more[0].bg != null
            ) {
              setaucbackbox(response.data.fpath + response.data.more[0].bg);
            }

            if (
              response.data.more[0].sstamp != "" &&
              response.data.more[0].sstamp != null
            ) {
              setaucstampbox(
                response.data.fpath + response.data.more[0].sstamp
              );
            }
            if (
              response.data.more[0].usstamp != "" &&
              response.data.more[0].usstamp != null
            ) {
              setaucustampbox(
                response.data.fpath + response.data.more[0].usstamp
              );
            }
          }
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };

  useEffect(() => {
    console.log("path is....");
    console.log(path);
  }, [path]);
  useEffect(() => {
    localStorage.removeItem("isFirstMount");
    window.scrollTo(0, 0);
    if (aucmoredetail == 0) {
      fetchdetail();
    } else {
      if (aid != aucmoredetail.detail.aid) {
        fetchdetail();
      } else {
        localStorage.setItem("auction_type", aucmoredetail.detail.acttype);

        if (aucmoredetail.detail.reg_player_on == 1) {
          setcheck1(true);
        }
        setaucdetail(aucmoredetail);
        if (aucmoredetail.more.length > 0) {
          if (aucmoredetail.more[0].bg != "") {
            setaucbackbox(aucmoredetail.fpath + aucmoredetail.more[0].bg);
          }

          if (
            aucmoredetail.more[0].sstamp != "" &&
            aucmoredetail.more[0].sstamp != null
          ) {
            setaucstampbox(aucmoredetail.fpath + aucmoredetail.more[0].sstamp);
          }
          if (
            aucmoredetail.more[0].usstamp != "" &&
            aucmoredetail.more[0].usstamp != null
          ) {
            setaucustampbox(
              aucmoredetail.fpath + aucmoredetail.more[0].usstamp
            );
          }
        }
      }
    }
    if (getTeampageData == 0) {
      fetchTeamData(0);
    } else {
      if (getTeampageData.responsedata.aid == aid) {
        let responsedata = getTeampageData.responsedata;
        setTeamData(responsedata);
        // setTeampath(responsedata.path);
      } else {
        let responsedata = getTeampageData.responsedata;
        responsedata.list = [];

        setData(responsedata);
        fetchTeamData(0);
      }
    }
    if (getPlayerspageData == 0) {
      fetchPlayersData();
    } else {
      if (getPlayerspageData.responsedata.aid == aid) {
        setpldata(getPlayerspageData.responsedata);
      } else {
        let responsedata = getPlayerspageData.responsedata;
        responsedata.list = [];
        setpldata(responsedata);
        fetchPlayersData(0);
      }
    }

    // Fetch category data
    fetchcatData();

    settempdata(localStorage.getItem("myData"));
    const handleBeforeUnload = () => { };

    window.addEventListener("beforeunload", handleBeforeUnload);
    localStorage.removeItem("isadel");
    if (getpageData == 0) {
      fetchaucData();
    } else {
      // console.log('getpageData.responsedata.path is....')
      // console.log(getpageData.responsedata.path)
      // console.log(getpageData.responsedata)
      // setPath(getpageData.responsedata.path);
      getpageData.responsedata.list.filter((ele, ind) => {
        if (ele.aid == aid) {
          localStorage.setItem("auction_name", ele.aname);
          setAData(ele);
          settimertyp(ele.istimer);
          setstarttime(ele.stime);
          setreftime(ele.rftime);
        }
      });
    }

    return () => {
      localStorage.removeItem("myData");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  useEffect(() => {
    // //  console.log(arraysEqual(upddata, isfirsttime))
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.type == "1") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);
  function settfp() {
    if (istfp == false) {
      setistfp(true);
    }
  }
  function settft() {
    if (istft == false) {
      setistft(true);
    }
  }
  const pltransfer = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    // if(pltraid < 48080 && aid > 48080){
    //   console.log('pltraid',pltraid)
    //   var hdr = {
    //     headers: {
    //       "Content-Type": "application/x-www-form-urlencoded",
    //       authorization: JSON.stringify([
    //         { cid: cid, aid: aid, token: loginuser["token"] },
    //       ]),
    //     },
    //   };
    //   const formData = new FormData();
    //   formData.append('phototype', 'players');
    //   formData.append('aid', '29390');
    //   await DataService.gettransferphotosdata(formData, hdr)
    //     .then((res) => {
    //       let response = res.data;
    //       toast.dismiss(toastContainerId);
    //        console.log('pl transfer photos response')
    //        console.log(response)
    //       if (response.success == true) {
    //         if(response.data.plist.length>0){
    //           (async () => {
    //             try {
    //               const photoTransferResponse = await axios.post(
    //                 'https://superscore.in/api/v1/spa/transfer-photos',
    //                 {
    //                   plist: response.data.plist
    //                 }
    //               );

    //               if (photoTransferResponse.data.success) {
    //                 toast.success("Photos transferred successfully!", {
    //                   theme: "dark",
    //                   position: "bottom-center"
    //                 });
    //               } else {
    //                 toast.error(photoTransferResponse.data.message || "Failed to transfer photos", {
    //                   theme: "colored",
    //                   position: "bottom-center"
    //                 });
    //               }
    //             } catch (error) {
    //               console.error("Error transferring photos:", error);
    //               toast.error("Failed to transfer photos to SuperScore", {
    //                 theme: "colored",
    //                 position: "bottom-center"
    //               });
    //             }
    //           })();
    //         }
    //         // //  console.log("setted")
    //         // setpltraid("");
    //       } else {
    //         if (response.msg != "")
    //           toast.error(response.msg, { theme: "colored" });
    //       }

    //       setActive(false);
    //     })
    //     .catch(() => {
    //       //  console.log("Not valid");
    //       toast.error("Not valid Server Error", { theme: "colored" });
    //       setActive(false);
    //     });

    // }

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var val = {};
    // val.aid=aid;
    val.faid = pltraid;
    await DataService.pltransfer(val, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // //  console.log(response)
        if (response.success == true) {
          toast.success("Player transferred successfully!", {
            theme: "dark",
            position: "bottom-center",
          });
          // //  console.log("setted")
          setpltraid("");
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const tmtransfer = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var val = {};
    // val.aid=aid;
    val.faid = tmtraid;
    await DataService.tmtransfer(val, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // //  console.log(response)
        if (response.success == true) {
          // //  console.log("setted")
          settmtraid("");
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const banneradd = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    const formData = new FormData();
    formData.append("bnrimg", aucbanner);

    await DataService.addbanner(formData, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // //  console.log(response)
        if (response.success == true) {
          const db = getDatabase();
          set(ref(db, "auction/info/" + aid), {
            type: "1",
            upd: "6",
            id: aid,
            detail: {
              typ: 15,
              upd: 1,
              val: response.data.newentry,
            },
            tkn: updtoken,
          });
          setaucbannerbox("");
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = "";
            }
          });
          setaucdetail((prev) => ({
            ...prev,
            bnr: [...prev.bnr, response.data.newentry],
          }));
          // //  console.log("setted")
          toast.success("Banner Added !!", {
            theme: "colored",
            position: "bottom-center",
          });

          setaucbanner("");
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const sponsoradd = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    const formData = new FormData();
    formData.append("splogo", aucsponsor);
    await DataService.addsponsor(formData, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // //  console.log(response)
        if (response.success == true) {
          const db = getDatabase();
          set(ref(db, "auction/info/" + aid), {
            type: "1",
            upd: "6",
            id: aid,
            detail: {
              typ: 14,
              upd: 1,
              val: response.data.newentry,
            },
            tkn: updtoken,
          });
          // //  console.log("setted")
          setaucsponsorbox("");
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = "";
            }
          });
          toast.success("Sponsor Added !!", {
            theme: "colored",
            position: "bottom-center",
          });

          setaucdetail((prev) => ({
            ...prev,
            spn: [...prev.spn, response.data.newentry],
          }));

          setaucsponsor("");
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const uploadfiles = async (typ) => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    const formData = new FormData();
    if (typ == "bg") {
      // if (aucbackbox == "") {

      //   formData.append("fl", aucback);
      // } else {
      //   alert('This background is already set !!')
      //   toast.dismiss(toastContainerId); // Dismiss the toast message here

      //   return 0
      // }
      formData.append("fl", aucback);

      const fileSizeKB = Math.round(aucback.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert("File size must be less than 1.25Mb");
        toast.dismiss(toastContainerId);
        return 0;
      }
    } else if (typ == "sstamp") {
      formData.append("fl", aucsoldstamp);
      const fileSizeKB = Math.round(aucsoldstamp.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert("File size must be less than 1.25Mb");
        toast.dismiss(toastContainerId);
        return 0;
      }
    } else if (typ == "usstamp") {
      formData.append("fl", aucunsoldstamp);
      const fileSizeKB = Math.round(aucunsoldstamp.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert("File size must be less than 1.25Mb");
        toast.dismiss(toastContainerId);
        return 0;
      }
    }

    formData.append("fltyp", typ);
    await DataService.addfiles(formData, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        if (response.success == true) {
          if (typ == "bg") {
            setaucdetail((detail) => ({
              ...detail,
              more: [{ ...detail.more[0], bg: response.data.newentry.logo }],
            }));
            setaucback("");
            const db = getDatabase();
            set(ref(db, "auction/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 13,
                upd: 1,
                val: { img: response.data.newentry.logo },
              },
              tkn: updtoken,
            });
          } else if (typ == "sstamp") {
            setaucdetail((detail) => ({
              ...detail,
              more: [
                { ...detail.more[0], sstamp: response.data.newentry.logo },
              ],
            }));
            setaucsoldstamp("");
          } else if (typ == "usstamp") {
            setaucdetail((detail) => ({
              ...detail,
              more: [
                { ...detail.more[0], usstamp: response.data.newentry.logo },
              ],
            }));
            setaucunsoldstamp("");
          }
          // //  console.log("setted")
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = "";
            }
          });
          toast.success("Added !!", {
            theme: "colored",
            position: "bottom-center",
          });

          // setaucdetail(prev => ({
          //   ...prev,
          //   spn: [...prev.spn, response.data.newentry]
          // }))
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  var stcls = "my-acution-top-top-relative";
  var mylblstyle = {
    background: "white",
  };
  if (adata.status == 1) {
    stcls += " Sblue";
  } else if (adata.status == 3) {
    stcls += " Syellow";
  } else if (adata.status == 5) {
    stcls += " Sgreen";
  } else {
    stcls += " Sred";
  }
  function acpgo() {
    // Build URL with query parameters for GET request
    // const baseUrl = "https://superplayerauction.com/manage/?frnt=1";
    const currentDomain = window.location.origin;
    const baseUrl = `${currentDomain}/manage/?frnt=1`;
    const params = new URLSearchParams({
      cid: cid,
      aid: aid,
      fkey: token,
    });
    const url = `${baseUrl}&${params.toString()}`;

    // Open in new tab
    window.open(url, "_blank");
  }
  function gotocustom() {
    history.push("/join-auction-customization");
  }
  const timerset = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var val = {};
    // val.aid = aid

    val.istimer = timertyp;
    val.stime = starttime;
    val.rftime = reftime;

    await DataService.settimer(val, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          const db = getDatabase();
          set(ref(db, "auction/info/" + aid), {
            type: "1",
            upd: "6",
            id: aid,
            detail: {
              typ: 11,
              val: { istimer: timertyp, stime: starttime, rftime: reftime },
            },
            tkn: updtoken,
          });

          const updateitem = getpageData.responsedata.list.filter(
            (ele, ind) => {
              if (ele.aid == aid) {
                ele.istimer = timertyp;
                ele.stime = starttime;
                ele.rftime = reftime;
              }
              return ele;
            }
          );
          let responsedata = {
            responsedata: {
              path: getpageData.responsedata.path,
              cid: cid,
              list: updateitem,
            },
          };
          dispatch(actlistData(responsedata));

          toast.success("Timer Updated !!", {
            theme: "colored",
            position: "bottom-center",
          });
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const boosterset = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var val = {};
    // val.aid = aid

    val.booster = booster;
    val.plno = plno;

    await DataService.setbooster(val, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          const db = getDatabase();
          set(ref(db, "auction/info/" + aid), {
            type: "1",
            upd: "6",
            id: aid,
            detail: {
              typ: 12,
              upd: 1,
              val: { point: booster, pl: plno },
            },
            tkn: updtoken,
          });
          toast.success("Booster Added !!", {
            theme: "colored",
            position: "bottom-center",
          });
          setaucdetail((prev) => ({
            ...prev,

            boost: prev.boost
              ? [...prev.boost, response.data.newentry]
              : [response.data.newentry],
          }));
          setbooster("");
          setplno("");
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const incrementset = async () => {
    //  console.log('here')
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var val = {};
    // val.aid = aid

    // val.aid = aid;
    val.bidup = incr;
    val.bi_point = incrafter;
    //  console.log('here2')

    await DataService.setbidincr(val, hdr)

      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        //  console.log(response)

        if (response.success == true) {
          //  console.log('response')
          //  console.log(response)
          // const db = getDatabase();
          // set(ref(db, 'auction/info/' + aid), {
          //   "type": "1", "upd": "6", 'id': aid, "detail": {
          //     "typ": 12,
          //     "upd": 1,
          //     "val": { point: booster, pl: plno },
          //   }, "tkn": updtoken
          // });
          toast.success("Booster Added !!", {
            theme: "colored",
            position: "bottom-center",
          });
          setaucdetail((prev) => ({
            ...prev,

            incr: prev.incr
              ? [...prev.incr, response.data.newentry]
              : [response.data.newentry],
          }));
          setincr("");
          setincrafter("");
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  function linkcopy(link) {
    // var linktext = 'https://superplayerauction.com/user/?acode=' + (adata !== "" && adata.acode);
    navigator.clipboard.writeText(link);
  }
  const checkhandle = async (t) => {
    // actions.isload(true)

    var x = 0;
    var y;
    if (t == 1) {
      setcheck1(!check1);
      x = document.getElementById("#checkbox").checked;
    }
    if (x == true) {
      y = 1;
    } else if (x == false) {
      y = 0;
    }
    const diffdoma = hideLayout ? 1 : 0;
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var val = {};

    val.typ = t;
    val.vl = y;
    val.diffdoma = diffdoma; 
    await DataService.updtrigger(val, hdr)
      .then((res) => {
        let response = res.data;
        // toast.dismiss(toastContainerId);

        if (response.success == true) {
          toast.success("Done !!", {
            theme: "colored",
            position: "bottom-center",
          });
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  function setimagepopup(item, t) {
    setisimgpop(true);
    setimgpopdata(item);
    setimgpoptype(t);
  }
  const removeuploads = async (t) => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var vals = {};
    if (t == "1") {
      vals.fltyp = "bg";
    } else if (t == "2") {
      vals.fltyp = "sstamp";
    } else if (t == "3") {
      vals.fltyp = "usstamp";
    }
    await DataService.delfiles(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          setisimgpop(false);
          if (t == "1") {
            setaucbackbox("");
            setaucdetail((detail) => ({
              ...detail,
              more: [{ ...detail.more[0], bg: "" }],
            }));
            const db = getDatabase();
            set(ref(db, "auction/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 13,
                upd: 2,
                val: "",
              },
              tkn: updtoken,
            });
          } else if (t == "2") {
            setaucstampbox("");
            setaucdetail((detail) => ({
              ...detail,
              more: [{ ...detail.more[0], sstamp: "" }],
            }));
          } else if (t == "3") {
            setaucustampbox("");
            setaucdetail((detail) => ({
              ...detail,
              more: [{ ...detail.more[0], usstamp: "" }],
            }));
          }
          toast.success("Removed !!", {
            theme: "colored",
            position: "bottom-center",
          });
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const delbooster = async (i) => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var vals = {};

    vals.i = i;
    await DataService.delbooster(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          const db = getDatabase();

          set(ref(db, "auction/info/" + aid), {
            type: "1",
            upd: "6",
            id: aid,
            detail: {
              typ: 12,
              upd: 2,
              val: { id: i },
            },
            tkn: updtoken,
          });
          setaucdetail((detail) => ({
            ...detail,
            boost: detail.boost.filter((sp) => sp.bsid != i),
          }));
          toast.success("Removed !!", {
            theme: "colored",
            position: "bottom-center",
          });
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const delincr = async (i) => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var vals = {};

    vals.i = i;
    await DataService.delincrpoint(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          // const db = getDatabase();

          // set(ref(db, 'auction/info/' + aid), {
          //   "type": "1", "upd": "6", 'id': aid, "detail": {
          //     "typ": 12,
          //     "upd": 2,
          //     "val": { id: i },
          //   }, "tkn": updtoken
          // });
          setaucdetail((detail) => ({
            ...detail,
            incr: detail.incr.filter((sp) => sp.piid != i),
          }));
          toast.success("Removed !!", {
            theme: "colored",
            position: "bottom-center",
          });
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const removefile = async (imgpoptype) => {
    if (imgpoptype == "3" || imgpoptype == "4" || imgpoptype == "5") {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          authorization: JSON.stringify([
            { cid: cid, aid: aid, token: loginuser["token"] },
          ]),
        },
      };
      var vals = {};

      if (imgpoptype == "3") {
        vals.fltyp = "bg";
      } else if (imgpoptype == "4") {
        vals.fltyp = "sstamp";
      } else if (imgpoptype == "5") {
        vals.fltyp = "usstamp";
      }
      await DataService.delfiles(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);

          if (response.success == true) {
            setisimgpop(false);
            if (imgpoptype == "3") {
              setaucdetail((detail) => ({
                ...detail,
                more: [{ ...detail.more[0], bg: "" }],
              }));
            } else if (imgpoptype == "4") {
              setaucdetail((detail) => ({
                ...detail,
                more: [{ ...detail.more[0], sstamp: "" }],
              }));
            } else if (imgpoptype == "5") {
              setaucdetail((detail) => ({
                ...detail,
                more: [{ ...detail.more[0], usstamp: "" }],
              }));
            }
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });
          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    } else if (imgpoptype == "2") {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          authorization: JSON.stringify([
            { cid: cid, aid: aid, token: loginuser["token"] },
          ]),
        },
      };
      var vals = {};
      vals.i = imgpopdata.spnid;

      await DataService.delspn(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);
          if (response.success == true) {
            const db = getDatabase();
            set(ref(db, "auction/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 14,
                upd: 2,
                val: imgpopdata.spnid,
              },
              tkn: updtoken,
            });
            setisimgpop(false);
            setaucdetail((detail) => ({
              ...detail,
              spn: detail.spn.filter((sp) => sp.spnid != imgpopdata.spnid),
            }));
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });
          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    } else if (imgpoptype == "1") {
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          authorization: JSON.stringify([
            { cid: cid, aid: aid, token: loginuser["token"] },
          ]),
        },
      };
      var vals = {};
      vals.i = imgpopdata.bnrid;

      await DataService.delbnr(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);
          if (response.success == true) {
            const db = getDatabase();
            set(ref(db, "auction/info/" + aid), {
              type: "1",
              upd: "6",
              id: aid,
              detail: {
                typ: 15,
                upd: 2,
                val: { id: imgpopdata.bnrid },
              },
              tkn: updtoken,
            });
            setisimgpop(false);
            setaucdetail((detail) => ({
              ...detail,
              bnr: detail.bnr.filter((bn) => bn.bnrid != imgpopdata.bnrid),
            }));
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });
          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          //  console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    }
  };
  const handleFileChange = (e, t) => {
    const file = e.target.files[0];
    if (t == "1") {
      setaucback(file);
    } else if (t == "2") {
      setaucsoldstamp(file);
    } else if (t == "3") {
      setaucunsoldstamp(file);
    } else if (t == "4") {
      setaucsponsor(file);
    } else if (t == "5") {
      setaucbanner(file);
    }
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (t == "1") {
          setaucbackbox(event.target.result);
        } else if (t == "2") {
          setaucstampbox(event.target.result);
        } else if (t == "3") {
          setaucustampbox(event.target.result);
        } else if (t == "4") {
          setaucsponsorbox(event.target.result);
        } else if (t == "5") {
          setaucbannerbox(event.target.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  function formlinkcopy(n, c) {
    navigator.clipboard.writeText(
      "You are invited to register yourself for " +
      n +
      " auction" +
      "\n" +
      "Join from this web link :" +
      "\n" +
      "https://superplayerauction.com/user?acode=" +
      c +
      "\n" +
      "Join from mobile app :" +
      "\n" +
      " https://superplayerauction.com/view/j/" +
      c
    );
    setiscopied(!iscopied);
    setTimeout(function () {
      setiscopied(false);
    }, 1000);
  }
  // function formlinkcopy2(n, c) {
  //   navigator.clipboard.writeText(
  //     "You are invited to register yourself for " +
  //       n +
  //       " auction" +
  //       "\n" +
  //       "Join from this web link :" +
  //       "\n" +
  //       "https://superplayerauction.com/user?acode=" +
  //       c +
  //       "&direct=1"
  //   );
  //   setiscopied2(!iscopied2);
  //   setTimeout(function () {
  //     setiscopied2(false);
  //   }, 1000);
  // }
  function formlinkcopy2(n, c) {
    navigator.clipboard.writeText(
      "You are invited to register yourself for " +
      n +
      " auction" +
      "\n" +
      "Join from this web link :" +
      "\n" +
      "https://superplayerauction.com/user?acode=" +
      c +
      "&direct=1" +
      "\n" +
      "Join from mobile app :" +
      "\n" +
      "https://superplayerauction.com/view/j/" +
      c +
      "/direct/1"
    );
    setiscopied2(!iscopied2);
    setTimeout(function () {
      setiscopied2(false);
    }, 1000);
  }
  function hispushform(c) {
    history.push("/?acode=" + c);
  }
  function hispushform2(c) {
    history.push("/?acode=" + c + "&direct=1");
  }
  const chooseback = async () => {
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.bglist({}, hdr)
      .then((res) => {
        let response = res.data;
        if (response.success == true) {
          setbgdata(response.data);
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
    setisbgpop(!isbgpop);
  };
  function showfullbg(ele) {
    setisfullbg(true);
    setbgfulldata(ele);
  }
  function handleDivClick(fl) {
    setselectedbgfl(fl);
  }
  const setbg = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    var vals = {};
    vals.fltyp = "bg";
    vals.fl = selectedbgfl;
    await DataService.setbg(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        if (response.success == true) {
          const db = getDatabase();
          set(ref(db, "auction/info/" + aid), {
            type: "1",
            upd: "6",
            id: aid,
            detail: {
              typ: 13,
              upd: 1,
              val: { img: response.data.newentry.logo },
            },
            tkn: updtoken,
          });
          setisbgpop(false);
          setselectedbgfl("");

          toast.success("Background set !!", {
            theme: "colored",
            position: "bottom-center",
          });
          setaucbackbox(bgdata.path + selectedbgfl);
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const transfertoscore = async (isOver, tnid) => {
    console.log("pldata........");
    console.log(pldata);
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    setisallreq(false);
    console.log("transfer teams");
    console.log(teamdata);
    //  console.log(data.list)

    try {
      if (
        tfmsg == "1" &&
        (!from_date || !to_date || !win_point || !type || !sname || !season)
      ) {
        setisallreq(true);
        return;
      }
      const trdata = {
        title: adata?.aname,
        logo: adata.logo,
        sports:
          adata.acttype == 0
            ? "Cricket"
            : adata.acttype == 1
              ? "Volleyball"
              : adata.acttype == 4
                ? "Badminton"
                : "",
        from_date: from_date,
        to_date: to_date,
        win_point: win_point,
        type: type,
        sname: sname,
        season: season,
        city: city,
        reg_date: new Date(),
        path: path,
      };
      // const sendplayers=pldata.list.map((player)=>{
      //   if(player.pcode=="83" || player.pcode=="84" || player.pcode=="85"){
      //     return player
      //   }

      // })
      const response = await axios.post(
        // "http://192.168.29.245:3000/api/v1/transfer",
        "https://superscore.in/api/v1/transfer",
        // "http://localhost:3000/api/v1/transfer",
        {
          teams: teamdata.list,
          players: pldata.list,
          category: catData,
          mobno: profile.mobno,
          trdata: trdata,
          isover: isOver,
          tnid: tnid,
        }
      );
      console.log("Response:", response.data);
      toast.dismiss(toastContainerId);

      if (response.data.success == true) {
        if (response.data.data.detail.type == 0) {
          settfmsg("1");
        }
        if (response.data.data.detail.type == 1) {
          settfmsg("2");
        }
        if (response.data.data.detail.type == 2) {
          settfmsg("3");
        }
        if (response.data.data.detail.type == 3) {
          settfmsg("4");
          setTourList(response.data.data.detail.list);
        }
      } else {
        settfmsg("0");
      }

      // You can handle success here (e.g., display a success message, reset form, etc.)
    } catch (error) {
      //  console.log('Error occurred while making POST request:', error);
      // Handle error here (e.g., show error message)
    }
  };

  return (
    <>
      {isbgpop && (
        <div id="bgdiv" className="bgdiv">
          <div className="bgpop themeboxmain">
            <div className="headsticky">
              <h3>
                Select Background
                <FontAwesomeIcon
                  onClick={() => {
                    isfullbg ? setisfullbg(false) : setisbgpop(false);
                  }}
                  style={{
                    position: "relative",
                    float: "right",
                    cursor: "pointer",
                  }}
                  icon={faXmark}
                />{" "}
              </h3>
            </div>
            {!isfullbg && (
              <div className="bgpopmain">
                {bgdata.list.map((ele) => {
                  return (
                    <div
                      key={ele.fl}
                      className={`bgimgdiv ${selectedbgfl == ele.fl ? "selbg" : ""
                        }`}
                      onClick={() => handleDivClick(ele.fl)}
                    >
                      <FontAwesomeIcon
                        onClick={() => showfullbg(ele)}
                        className="imgzoom"
                        icon={faExpand}
                      />
                      <img src={bgdata.path + ele.fl} alt="" />
                      {selectedbgfl == ele.fl && (
                        <button onClick={() => setbg()} className="bgsetbtn">
                          set
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
            {isfullbg && (
              <div className="bgpopmain">
                <img
                  className="bgfullimg"
                  src={bgdata.path + bgfulldata.fl}
                  alt="background"
                />
              </div>
            )}
          </div>
        </div>
      )}
      <Navigationtitle data={match} />
      <div>
        <form
          id="acpform"
          method="get"
          action="https://superplayerauction.com/manage/?frnt=1"
          target="_blank"
        >
          <input type="hidden" id="acp1" name="cid" />
          <input type="hidden" id="acp2" name="aid" />
          <input type="hidden" id="acp3" name="fkey" />
          {/* <input type="hidden" name="loginbyadmin" value="1" /> */}
        </form>
        {isimgpop && (
          <>
            <div className="impopbg"></div>
            <div className="impopmain">
              <div>
                <h3>
                  {imgpoptype == "2" && "Sponsor"}
                  {imgpoptype == "1" && "Banner"}
                  <FontAwesomeIcon
                    onClick={() => setisimgpop(false)}
                    style={{
                      padding: ".5rem",
                      cursor: "pointer",
                      position: "relative",
                      float: "right",
                    }}
                    icon={faXmark}
                  />
                </h3>
              </div>
              <div>
                {imgpoptype == "2" && (
                  <img src={aucdetail.spath + imgpopdata.logo} alt="" />
                )}
                {imgpoptype == "1" && (
                  <img src={aucdetail.bpath + imgpopdata.img} alt="" />
                )}
                {imgpoptype == "3" && (
                  <img src={aucdetail.fpath + imgpopdata} alt="" />
                )}
                {imgpoptype == "4" && (
                  <img src={aucdetail.fpath + imgpopdata} alt="" />
                )}
                {imgpoptype == "5" && (
                  <img src={aucdetail.fpath + imgpopdata} alt="" />
                )}
              </div>
              <div
                onClick={() => removefile(imgpoptype)}
                style={{
                  padding: ".5rem",
                  cursor: "pointer",
                  position: "relative",
                  float: "right",
                }}
              >
                {" "}
                <FontAwesomeIcon
                  style={{ marginRight: ".5rem" }}
                  icon={faTrash}
                />
                Remove
              </div>
            </div>
          </>
        )}
        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className=" nopadd">
            <section className="event-area">
              {/* <span onClick={acpgo} style={{ fontWeight: "bold" }} className="acp">Go to Auction Panel <FontAwesomeIcon className="arright" icon={faArrowRight} /></span> */}
              <div className="container-fluid nopadd">
                {tempdata}
                {adata != "" ? (
                  <div>
                    <div>
                      <div className="auctionpanel_parent">
                        <span
                          onClick={acpgo}
                          style={{ fontWeight: "bold" }}
                          className="acp"
                        >
                          Go to Auction Panel{" "}
                          <FontAwesomeIcon
                            className="arright"
                            icon={faArrowRight}
                          />
                        </span>
                      </div>
                      <div className="auction-details-top">
                        <div className="aucheadflex">
                          <div className="auction-details-top-left">
                            {" "}
                            <div className="image-div">
                              <img
                                src={
                                  adata.logo == ""
                                    ? auctiondefaultLogo
                                    : path + adata.logo
                                }
                                alt="logo"
                                style={{ height: "70px" }}
                              />
                            </div>
                            <div className="aucinfodiv">
                              <h6 className="auction-heading2">
                                {adata.aname}{" "}
                                {adata.status == 1 || adata.status == 3 ? (
                                  <MdVerified
                                    title="Activated"
                                    className="aucbadge"
                                  />
                                ) : adata.status == 5 ? (
                                  <MdVerified
                                    title="Completed"
                                    className="aucbadge2"
                                  />
                                ) : (
                                  <LuBadgeAlert
                                    title="Deactive / Payment not done"
                                    className="aucbadge3"
                                    onClick={() =>
                                      history.push(
                                        BASE_PATH + "auction-payment"
                                      )
                                    }
                                  />
                                )}
                              </h6>
                              <div className="auction-subheading2">
                                A-Code: {adata.acode}
                              </div>

                              <div className="auction-details-display-left aucdatecontainer">
                                <div style={{ paddingRight: "5px" }}>
                                  {svg.clender}
                                </div>
                                <div>
                                  {dateFormat(adata.dt, "d mmm, yyyy")}{" "}
                                  &nbsp;&nbsp;{adata.atm}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="auction-details-display-right">
                            <div className="auction-details-display-right-item">
                              <Link to="/auction-team">
                                {" "}
                                <div>{svg.team}</div>
                                <div className="auction-details-text-color">
                                  Team
                                </div>
                              </Link>
                            </div>
                            <div className="auction-details-display-right-item">
                              <Link to="/auction-category">
                                {" "}
                                <div>{svg.category}</div>
                                <div className="auction-details-text-color">
                                  Category
                                </div>
                              </Link>
                            </div>
                            <div className="auction-details-display-right-item">
                              <Link to="/auction-players">
                                {" "}
                                <div>{svg.players}</div>
                                <div className="auction-details-text-color">
                                  Players
                                </div>
                              </Link>
                            </div>
                            {/* <div className="auction-details-display-right-item">
                            <Link>
                              {" "}
                              <div>{svg.report}</div>
                              <div className="auction-details-text-color">
                                Report
                              </div>
                            </Link>
                          </div> */}
                            <div className="auction-details-display-right-item">
                              <Link to={"/edit-auction/" + encode(aid)}>
                                {" "}
                                <div>{svg.edit}</div>
                                <div className="auction-details-text-color">
                                  Edit
                                </div>
                              </Link>
                            </div>
                            <div className="auction-details-display-right-item">
                              <Link onClick={() => deldata(aid)}>
                                {" "}
                                <div>{svg.delete}</div>
                                <div className="auction-details-text-color">
                                  Delete
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div></div>
                      </div>
                      {/* <div className="myflex">

                        <div className="auction-details-card-container">
                          <div className="auction-details-card-container-top">
                            <div className="auction-details-display-flex">
                              <div className="auction-details-display-left">
                                <div style={{ paddingRight: "5px" }}>
                                  {svg.clender}
                                </div>
                                <div>{dateFormat(adata.dt, "d mmm, yyyy")} &nbsp;&nbsp;{adata.atm}
                                </div>
                              </div>
                              <div className={stcls} style={{ cursor: 'pointer' }} onClick={() => {
                                if (adata.status == 6) {
                                  history.push(BASE_PATH + 'auction-payment')
                                }
                              }}>
                                {svg.lblsvg2}

                                <div className="my-acution-top-top-absolute dtsts">
                                  {adata.status == 1 ? "ACTIVE" : adata.status == 3 ? "RUNING" : adata.status == 5 ? "COMPLETED" : "DEACTIVE"}
                                </div>
                              </div>

                            </div>
                          </div>
                          <div className="auction-details-card-container-bottom">
                            <div className="row">
                              <div className="col-xs-12 col-md-6 display-flex detpart padding-bottom">
                                <div className="auction-details-bottom-container-text-left">
                                  Point
                                </div>
                                <div className="auction-details-bottom-container-text-right">
                                  {adata.totalpoint}
                                </div>
                              </div>
                              <div className="col-xs-12 col-md-6 display-flex detpart2  padding-bottom">
                                <div className="auction-details-bottom-container-text-left">
                                  Bid Incr
                                </div>
                                <div className="auction-details-bottom-container-text-right">
                                  {adata.bidup}
                                </div>
                              </div>
                              <div className="col-xs-12 col-md-6 display-flex detpart padding-bottom">
                                <div className="auction-details-bottom-container-text-left">
                                  Basic Bid
                                </div>
                                <div className="auction-details-bottom-container-text-right">
                                  {adata.minbid}
                                </div>
                              </div>
                              <div className="col-xs-12 col-md-6 display-flex detpart2  padding-bottom">
                                <div className="width-25px">
                                  {svg.playerperteam}
                                </div>
                                <div className="auction-details-bottom-container-text-right">
                                  {adata.player} PL/Team
                                </div>
                              </div>
                            </div>
                          </div>
                          {adata.status == 6 && <div onClick={() => history.push(BASE_PATH + 'auction-payment')} className="activePayment"> Pay now to Activate</div>} </div>
                        <div className="auction-details-card-container2 transpl plregfrm">

                          <div className="striphead plstriphead">
                            <div></div>
                            <h3>Player Self Registration Form</h3>

                            <div class="pflex1 switchflex">

                              <div>
                                <label class="switch labelmargin">
                                  <input type="checkbox" id="#checkbox" checked={check1} onClick={() => checkhandle(1)} />
                                  <span class="slider round"></span>
                                </label>
                              </div>
                              <Link to='join-auction-customization'> <button className="mydesbtn">Customize</button></Link>
                            </div>

                          </div>
                          <div className="pflex1">

                          </div>
                          <div className="plregdiv">
                            <div className="sharediv">

                              <div className="sharemsgbox">
                                <div>


                                  <h3><b>Share form link :</b></h3>
                                  <p>You are invited to register yourself for the {adata ? adata.aname : 'Auction'} auction</p>
                                  <p>Join from web link:</p>
                                  <p style={{ cursor: 'pointer' }} onClick={() => hispushform(adata !== "" && adata.acode)} className="regfrmlink">https://superplayerauction.com/user?acode={adata !== "" && adata.acode}</p>
                                  <p>Join from the mobile app:</p>
                                  <a href={'https://superplayerauction.com/view/j/' + adata !== "" && adata.acode}>  <p style={{ cursor: 'pointer' }} className="regfrmlink">https://superplayerauction.com/view/j/{adata !== "" && adata.acode}</p></a>
                                </div>
                                <div>

                                  <button onClick={() => formlinkcopy(adata ? adata.aname : 'Auction', adata !== "" && adata.acode)} className="mydesbtn copybtn">{iscopied ? 'Copied' : 'Copy'}</button>
                                </div>
                              </div>
                              <div className="sharemsgbox">
                                <div>

                                  <h3><b>Share form link ( No login required ) :</b></h3>
                                  <p>You are invited to register yourself for the {adata ? adata.aname : 'Auction'} auction</p>
                                  <p>Join from web link:</p>
                                  <p style={{ cursor: 'pointer' }} onClick={() => hispushform2(adata !== "" && adata.acode)} className="regfrmlink">https://superplayerauction.com/user?acode={adata !== "" && adata.acode}&direct=1</p>
                                </div>

                                <div>

                                  <button onClick={() => formlinkcopy2(adata ? adata.aname : 'Auction', adata !== "" && adata.acode)} className="mydesbtn copybtn">{iscopied ? 'Copied' : 'Copy'}</button>
                                </div>
                              </div>
                            </div>

                          </div>

                        </div>

                      </div> */}
                      <div className="myflex">
                        <div className="auction-details-card-container">
                          <div
                            className="auction-details-card-container-bottom"
                            style={{
                              display: "grid",
                              gap: "29px",
                            }}
                          >
                            {/* <div className="row"> */}
                            <div
                              className="col-xs-12 col-md-6 custom-col display-flex detpart"
                              style={{
                                justifyContent: "space-between",
                                width: "70%",
                              }}
                            >
                              <div className="auction-details-bottom-container-text-left">
                                Balance
                              </div>
                              <div className="auction-details-bottom-container-text-right">
                                {adata.totalpoint} {adata.unit}
                              </div>
                            </div>
                            <div
                              className="col-xs-12 col-md-6 custom-col display-flex detpart"
                              style={{
                                justifyContent: "space-between",
                                width: "70%",
                              }}
                            >
                              <div className="auction-details-bottom-container-text-left">
                                Base Bid
                              </div>
                              <div className="auction-details-bottom-container-text-right">
                                {adata.minbid}
                              </div>
                            </div>
                            {/* </div> */}
                            {/* <div className="row"> */}
                            <div
                              className="col-xs-12 col-md-6 custom-col display-flex detpart2"
                              style={{
                                justifyContent: "space-between",
                                width: "70%",
                              }}
                            >
                              <div className="auction-details-bottom-container-text-left">
                                Bid Increment
                              </div>
                              <div className="auction-details-bottom-container-text-right">
                                {adata.bidup}
                              </div>
                            </div>
                            <div
                              className="col-xs-12 col-md-6 custom-col display-flex detpart2"
                              style={{
                                justifyContent: "space-between",
                                width: "70%",
                              }}
                            >
                              <div className="width-25px auction-details-bottom-container-text-left">
                                {/* {svg.playerperteam} */}
                                Players
                              </div>
                              <div className="auction-details-bottom-container-text-right">
                                {adata.player} /Team
                              </div>
                            </div>
                            {/* </div> */}
                          </div>

                          {adata.status == 6 && (
                            <div
                              onClick={() =>
                                history.push(BASE_PATH + "auction-payment")
                              }
                              className="activePayment"
                            >
                              {" "}
                              Pay now to Activate
                            </div>
                          )}
                        </div>
                        <div className="auction-details-card-container2 links-container">
                          <div>
                            <div>
                              <div>
                                <label
                                  onClick={acpgo}
                                  style={{ cursor: "pointer" }}
                                  htmlFor=""
                                >
                                  Go to Auction Panel{" "}
                                </label>
                              </div>
                              <div>
                                <span></span>
                              </div>
                            </div>
                            <div>
                              <div>
                                <label htmlFor="">
                                  Public View{" "}
                                  <FontAwesomeIcon
                                    onClick={() =>
                                      linkcopy(
                                        `https://superplayerauction.com/auctions.php?actid=${adata.aid}#1`
                                      )
                                    }
                                    icon={faCopy}
                                    className="copyicon"
                                  />{" "}
                                </label>
                              </div>
                              <div>
                                <a
                                  href={`https://superplayerauction.com/auctions.php?actid=${adata.aid}#1`}
                                  target="_blank"
                                >
                                  https://superplayerauction.com/auctions.php?actid=
                                  {adata.aid}#1
                                </a>
                              </div>
                            </div>
                            <div>
                              <div>
                                <label htmlFor="">Overlay Links </label>
                              </div>
                              <div>
                                <a
                                  href={`https://superplayerauction.com/manage/ov/?actid=${adata.aid}`}
                                  target="_blank"
                                >
                                  https://superplayerauction.com/manage/ov/?actid=
                                  {adata.aid}
                                </a>
                                <FontAwesomeIcon
                                  onClick={() =>
                                    linkcopy(
                                      `https://superplayerauction.com/manage/ov/?actid=${adata.aid}`
                                    )
                                  }
                                  icon={faCopy}
                                  className="copyicon"
                                />
                              </div>
                              <div>
                                <a
                                  href={`https://superplayerauction.com/manage/ov/?actid=${adata.aid}&th=2`}
                                  target="_blank"
                                >
                                  https://superplayerauction.com/manage/ov/?actid=
                                  {adata.aid}&th=2
                                </a>
                                <FontAwesomeIcon
                                  onClick={() =>
                                    linkcopy(
                                      `https://superplayerauction.com/manage/ov/?actid=${adata.aid}&th=2`
                                    )
                                  }
                                  icon={faCopy}
                                  className="copyicon"
                                />
                              </div>
                              <div>
                                <a
                                  href={`https://superplayerauction.com/manage/ov/?actid=${adata.aid}&th=3`}
                                  target="_blank"
                                >
                                  https://superplayerauction.com/manage/ov/?actid=
                                  {adata.aid}&th=3
                                </a>
                                <FontAwesomeIcon
                                  onClick={() =>
                                    linkcopy(
                                      `https://superplayerauction.com/manage/ov/?actid=${adata.aid}&th=3`
                                    )
                                  }
                                  icon={faCopy}
                                  className="copyicon"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="myflex">
                        <div className="auction-details-card-container2 transpl plregfrm">
                          <div className="striphead plstriphead">
                            <h3>
                              Player Self Registration Form
                              <div class="pflex1 switchflex">
                                <div>
                                  <label class="switch labelmargin">
                                    <input
                                      type="checkbox"
                                      id="#checkbox"
                                      checked={check1}
                                      onClick={() => checkhandle(1)}
                                    />
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </h3>
                            <div>
                              <span
                                // onClick={() => setShowLimitModal(true)}
                                onClick={() => {
                                  fetchLimit();
                                  setShowLimitModal(true);
                                }}
                                className="regformlimitlink setlimitlink setlimit"
                              >
                                Set Limit
                              </span>
                              <Link to="join-auction-customization">
                                {" "}
                                <button className="mydesbtn formcustombtn">
                                  Form Customization
                                </button>
                              </Link>
                            </div>
                            {showLimitModal && (
                              <div
                                style={{
                                  position: "fixed",
                                  top: 0,
                                  left: 0,
                                  width: "100vw",
                                  height: "100vh",
                                  backgroundColor: "rgba(0, 0, 0, 0.85)",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  zIndex: 9999,
                                  backdropFilter: "blur(5px)",
                                  animation: "fadeIn 0.3s ease-out forwards",
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: "white",
                                    width: "90%",
                                    maxWidth: "480px",
                                    borderRadius: "16px",
                                    boxShadow: "0 25px 50px rgba(0, 0, 0, 0.3)",
                                    padding: "32px",
                                    position: "relative",
                                    animation: "slideUp 0.4s ease-out forwards",
                                  }}
                                >
                                  {/* Header */}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      marginBottom: "24px",
                                    }}
                                  >
                                    <h2
                                      style={{
                                        fontSize: "22px",
                                        fontWeight: "bold",
                                        color: "#1f2937",
                                        margin: 0,
                                      }}
                                    >
                                      Set Registration Limit
                                    </h2>
                                    <button
                                      onClick={() => setShowLimitModal(false)}
                                      style={{
                                        background: "none",
                                        border: "none",
                                        fontSize: "28px",
                                        color: "#6b7280",
                                        cursor: "pointer",
                                        width: "36px",
                                        height: "36px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "50%",
                                        transition: "all 0.2s",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.target.style.backgroundColor =
                                          "#f3f4f6";
                                        e.target.style.color = "#374151";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.backgroundColor =
                                          "transparent";
                                        e.target.style.color = "#6b7280";
                                      }}
                                    >
                                      <AiOutlineClose />
                                    </button>
                                  </div>

                                  {/* Form Content */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "20px",
                                    }}
                                  >
                                    {/* Player Limit */}
                                    <div>
                                      <label
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                          cursor: "pointer",
                                          fontWeight: "500",
                                          color: "#374151",
                                          fontSize: "15px",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={enablePlayerLimit}
                                          onChange={() => {
                                            setEnablePlayerLimit(
                                              !enablePlayerLimit
                                            );
                                            if (!enablePlayerLimit)
                                              setPlayerLimitValue("");
                                          }}
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                        />
                                        Registration Limit (Players)
                                      </label>

                                      {enablePlayerLimit && (
                                        <div
                                          style={{
                                            marginTop: "12px",
                                            marginLeft: "28px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                          }}
                                        >
                                          <input
                                            type="number"
                                            min="1"
                                            placeholder="Enter number"
                                            value={playerLimitValue}
                                            onChange={(e) =>
                                              setPlayerLimitValue(
                                                e.target.value
                                              )
                                            }
                                            style={{
                                              padding: "10px 12px",
                                              borderRadius: "8px",
                                              border: "1px solid #d1d5db",
                                              width: "130px",
                                              fontSize: "15px",
                                            }}
                                          />
                                          {/* <button
                                            onClick={() => {
                                              if (
                                                playerLimitValue &&
                                                parseInt(playerLimitValue) > 0
                                              ) {
                                                alert(
                                                  `Player limit set to: ${playerLimitValue}`
                                                );
                                              }
                                            }}
                                            style={{
                                              padding: "8px 16px",
                                              backgroundColor: "#3b82f6",
                                              color: "white",
                                              border: "none",
                                              borderRadius: "8px",
                                              fontWeight: "500",
                                              cursor: "pointer",
                                            }}
                                          >
                                            Set
                                          </button> */}
                                        </div>
                                      )}
                                    </div>

                                    {/* Date Limit */}
                                    <div>
                                      <label
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                          cursor: "pointer",
                                          fontWeight: "500",
                                          color: "#374151",
                                          fontSize: "15px",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={enableDateLimit}
                                          onChange={() => {
                                            setEnableDateLimit(
                                              !enableDateLimit
                                            );
                                            if (!enableDateLimit) {
                                              setDateLimitValue("");
                                              setDateTimeValue("");
                                            }
                                          }}
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                        />
                                        Date Limit
                                      </label>

                                      {enableDateLimit && (
                                        <div
                                          style={{
                                            marginTop: "12px",
                                            marginLeft: "28px",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "10px",
                                          }}
                                        >
                                          <input
                                            type="date"
                                            value={dateLimitValue}
                                            onChange={(e) =>
                                              setDateLimitValue(e.target.value)
                                            }
                                            style={{
                                              padding: "10px 12px",
                                              borderRadius: "8px",
                                              border: "1px solid #d1d5db",
                                              fontSize: "15px",
                                            }}
                                          />

                                          <input
                                            type="time"
                                            value={dateTimeValue}
                                            onChange={(e) =>
                                              setDateTimeValue(e.target.value)
                                            }
                                            style={{
                                              padding: "10px 12px",
                                              borderRadius: "8px",
                                              border: "1px solid #d1d5db",
                                              fontSize: "15px",
                                            }}
                                          />

                                          <button
                                            onClick={() => {
                                              setDateLimitValue("");
                                              setDateTimeValue("");
                                            }}
                                            style={{
                                              padding: "8px 16px",
                                              backgroundColor: "#ef4444",
                                              color: "white",
                                              border: "none",
                                              borderRadius: "8px",
                                              fontWeight: "500",
                                              cursor: "pointer",
                                            }}
                                          >
                                            Remove
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  {/* Submit Button */}
                                  <div
                                    style={{
                                      marginTop: "28px",
                                      textAlign: "right",
                                    }}
                                  >
                                    <button
                                      onClick={async () => {
                                        // If nothing selected, save empty values
                                        if (
                                          !enablePlayerLimit &&
                                          !enableDateLimit
                                        ) {
                                          await saveLimitToServer({
                                            player_limit: "",
                                            date_limit: "",
                                            time_limit: "",
                                          });

                                          setShowLimitModal(false);
                                          return;
                                        }

                                        // Player limit validation
                                        if (
                                          enablePlayerLimit &&
                                          !playerLimitValue
                                        ) {
                                          alert(
                                            "Please enter player limit value."
                                          );
                                          return;
                                        }

                                        // Date limit validation
                                        if (
                                          enableDateLimit &&
                                          !dateLimitValue &&
                                          !dateTimeValue
                                        ) {
                                          alert("Please select date or time.");
                                          return;
                                        }

                                        await saveLimitToServer(); // your normal save
                                        setShowLimitModal(false);
                                      }}
                                      style={{
                                        padding: "12px 28px",
                                        backgroundColor: "#10b981",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "10px",
                                        fontWeight: "600",
                                        fontSize: "16px",
                                        cursor: "pointer",
                                        transition: "background 0.2s",
                                      }}
                                      onMouseEnter={(e) =>
                                      (e.target.style.backgroundColor =
                                        "#059669")
                                      }
                                      onMouseLeave={(e) =>
                                      (e.target.style.backgroundColor =
                                        "#10b981")
                                      }
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="plregdiv">
                            <div className="sharediv">
                              <div className="sharemsgbox">
                                <div>
                                  <h3 className="shareHead">
                                    SHARE FORM LINK
                                    <div className="copydiv">
                                      <button
                                        onClick={() =>
                                          formlinkcopy(
                                            adata ? adata.aname : "Auction",
                                            adata !== "" ? adata.acode : ""
                                          )
                                        }
                                        className="mydesbtn copybtn"
                                      >
                                        {iscopied ? "Copied" : "Copy"}
                                      </button>
                                    </div>
                                  </h3>
                                  <p>
                                    You are invited to register yourself for the{" "}
                                    {adata ? adata.aname : "Auction"} auction
                                  </p>
                                  <p>Join from web link:</p>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      hispushform(
                                        adata !== "" ? adata.acode : ""
                                      )
                                    }
                                    className="regfrmlink"
                                  >
                                    https://superplayerauction.com/user?acode=
                                    {adata !== "" ? adata.acode : ""}
                                  </p>
                                  <p>Join from the mobile app:</p>
                                  <a
                                    href={
                                      "https://superplayerauction.com/view/j/" +
                                        adata !==
                                        ""
                                        ? adata.acode
                                        : ""
                                    }
                                  >
                                    {" "}
                                    <p
                                      style={{ cursor: "pointer" }}
                                      className="regfrmlink"
                                    >
                                      https://superplayerauction.com/view/j/
                                      {adata !== "" ? adata.acode : ""}
                                    </p>
                                  </a>
                                </div>
                              </div>
                              <div className="sharemsgbox">
                                <div>
                                  <h3 className="shareHead">
                                    SHARE FORM LINK ( No login required )
                                    <div className="copydiv">
                                      <button
                                        onClick={() =>
                                          formlinkcopy2(
                                            adata ? adata.aname : "Auction",
                                            adata !== "" ? adata.acode : ""
                                          )
                                        }
                                        className="mydesbtn copybtn"
                                      >
                                        {iscopied2 ? "Copied" : "Copy"}
                                      </button>
                                    </div>
                                  </h3>
                                  <p>
                                    You are invited to register yourself for the{" "}
                                    {adata ? adata.aname : "Auction"} auction
                                  </p>
                                  <p>Join from web link:</p>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      hispushform2(
                                        adata !== "" ? adata.acode : ""
                                      )
                                    }
                                    className="regfrmlink"
                                  >
                                    https://superplayerauction.com/user?acode=
                                    {adata !== "" ? adata.acode : ""}&direct=1
                                  </p>
                                  <p>Join from App:</p>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      window.open(
                                        `https://superplayerauction.com/view/j/${adata !== "" ? adata.acode : ""
                                        }/direct/1`,
                                        "_blank"
                                      )
                                    }
                                    className="regfrmlink"
                                  >
                                    https://superplayerauction.com/view/j/
                                    {adata !== "" ? adata.acode : ""}/direct/1
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="myflex">
                        <div className="auction-details-card-container2 timerflex timerdiv">
                          <div className="timersetting">
                            <div className="striphead">
                              <h3>Timer Setting</h3>
                            </div>
                            <div className="strip">
                              <div>
                                <label
                                  for="inputPassword4"
                                  classname="form-label timelbl"
                                >
                                  Timer
                                </label>
                              </div>
                              <div className="stripmain">
                                <select
                                  id="inputState"
                                  value={timertyp}
                                  onChange={(e) => settimertyp(e.target.value)}
                                  class="form-select"
                                >
                                  <option value="0" selected>
                                    Off
                                  </option>
                                  <option value="1">Auto</option>
                                  <option value="2">Manual</option>
                                </select>
                              </div>
                            </div>
                            <div className="strip">
                              <div>
                                <label for="inputEmail4" class="form-label">
                                  Start (sec)
                                </label>
                              </div>
                              <div className="stripmain">
                                <input
                                  type="number"
                                  class="form-control"
                                  value={starttime}
                                  onChange={(e) => setstarttime(e.target.value)}
                                  id="inputEmail4"
                                />
                              </div>
                            </div>
                            <div className="strip">
                              <div>
                                <label for="inputEmail4" class="form-label">
                                  Refresh (sec):
                                </label>
                                &nbsp;&nbsp;&nbsp;
                              </div>
                              <div className="stripmain">
                                <input
                                  type="number"
                                  class="form-control"
                                  value={reftime}
                                  onChange={(e) => setreftime(e.target.value)}
                                  id="inputEmail4"
                                />
                              </div>
                            </div>
                            <div className="btndiv">
                              <button
                                onClick={() => timerset()}
                                className="mydesbtn timerbtn"
                              >
                                Set
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="auction-details-card-container2 timerflex boosterdiv">
                          <div className="boostersetting">
                            <div className="striphead">
                              <h3>Booster Setting</h3>
                            </div>
                            <div className="strip strip2 ">
                              <input
                                type="number"
                                class="form-control"
                                value={booster}
                                onChange={(e) => setbooster(e.target.value)}
                                placeholder="Booster"
                                id="inputEmail4"
                              />
                              <label
                                for="inputEmail4"
                                class="form-label hand1 commonlabel"
                              >
                                After
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                id="inputEmail4"
                                value={plno}
                                onChange={(e) => setplno(e.target.value)}
                              />
                              <div>
                                <button
                                  onClick={() => boosterset()}
                                  class="setbtn mydesbtn"
                                >
                                  ADD
                                </button>
                              </div>
                            </div>
                            {aucdetail != "" && aucdetail.boost ? (
                              aucdetail.boost.map((ele) => {
                                return (
                                  <div className="boosters">
                                    Boost<span>{ele.point}</span> after{" "}
                                    <span>{ele.pl}</span> Players &nbsp;
                                    <MdDeleteOutline
                                      onClick={() => delboostdata(ele.bsid)}
                                      className="boostertrash"
                                    />
                                  </div>
                                );
                              })
                            ) : (
                              <div className="boosternomsg">
                                <p>Currently no booster applied</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="myflex">
                        <div className="auction-details-card-container2 timerflex boosterdiv">
                          <div className="boostersetting">
                            <div className="striphead">
                              <h3>Bid Increment</h3>
                            </div>
                            <div className="strip strip2 ">
                              <input
                                type="number"
                                class="form-control"
                                value={incr}
                                onChange={(e) => setincr(e.target.value)}
                                id="inputEmail4"
                              />
                              <label
                                for="inputEmail4"
                                class="form-label hand1 commonlabel"
                              >
                                Incr.
                              </label>
                              <label
                                for="inputEmail4"
                                class="form-label hand1 commonlabel"
                              >
                                After
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                id="inputEmail4"
                                value={incrafter}
                                onChange={(e) => setincrafter(e.target.value)}
                              />
                              <div>
                                <button
                                  onClick={() => incrementset()}
                                  class="setbtn mydesbtn"
                                >
                                  ADD
                                </button>
                              </div>
                            </div>
                            {aucdetail != "" && aucdetail.incr ? (
                              aucdetail.incr.map((ele) => {
                                return (
                                  <div className="boosters">
                                    Increment<span>{ele.bidup}</span> after{" "}
                                    <span>{ele.points}</span> Points &nbsp;
                                    <MdDeleteOutline
                                      onClick={() => delincrdata(ele.piid)}
                                      className="boostertrash"
                                    />
                                  </div>
                                );
                              })
                            ) : (
                              <div className="boosternomsg">
                                <p>Currently no Increment applied</p>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="auction-details-card-container2 timerflex boosterdiv">
                          <div className="boostersetting">
                            <div className="striphead">
                              <h3>Overlay Customization</h3>
                            </div>
                            <div className="strip strip2 ">
                              <div>
                                Customize your overlay for live streaming with
                                diffrent colors , themes , data.
                              </div>
                              <div>
                                <button
                                  onClick={() =>
                                    history.push("/overlay-customization")
                                  }
                                  class="setbtn mydesbtn"
                                >
                                  Customize
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="auction-details-card-container2 customize-box premium-customize-box">
                        <div className="premium-customize-content">
                          Customize your Auction Theme, also various things
                          (Background, Stamps , Sold Effects , audio)
                        </div>
                        <div className="cusdiv">
                          <Link to={"auction-customization"}>
                            {" "}
                            <button className="mydesbtn custombtn premium-customize-btn">
                              Customize
                            </button>
                          </Link>
                        </div>
                      </div>

                      {/* Add the new CSS styles for premium customize box */}
                      <style jsx>{`
                        .premium-customize-box {
                          border: 2px solid #6c3483;
                          background: linear-gradient(145deg, #f8f9fa, #e9ecef);
                          box-shadow: 0 10px 20px rgba(108, 52, 131, 0.2);
                          border-radius: 12px;
                          position: relative;
                          overflow: hidden;
                          transition: all 0.3s ease;
                        }

                        .premium-customize-box:hover {
                          transform: translateY(-5px);
                          box-shadow: 0 15px 30px rgba(108, 52, 131, 0.3);
                          border-color: #8e44ad;
                        }

                        .premium-customize-box:before {
                          content: "";
                          position: absolute;
                          top: 0;
                          left: 0;
                          width: 100%;
                          height: 5px;
                          background: linear-gradient(
                            90deg,
                            #6c3483,
                            #8e44ad,
                            #9b59b6
                          );
                          z-index: 1;
                        }

                        .premium-customize-content {
                          font-weight: 500;
                          color: #333;
                          padding: 10px 5px;
                          border-left: 4px solid #8e44ad;
                          margin: 10px 0;
                          background-color: rgba(142, 68, 173, 0.05);
                          border-radius: 0 8px 8px 0;
                        }

                        .premium-customize-btn {
                          background: linear-gradient(
                            135deg,
                            #8e44ad,
                            #6c3483
                          ) !important;
                          border: none !important;
                          color: white !important;
                          font-weight: 600 !important;
                          letter-spacing: 0.5px !important;
                          padding: 10px 25px !important;
                          border-radius: 30px !important;
                          transition: all 0.3s ease !important;
                          position: relative;
                          overflow: hidden;
                          z-index: 1;
                        }

                        .premium-customize-btn:hover {
                          transform: scale(1.05);
                          box-shadow: 0 5px 15px rgba(108, 52, 131, 0.4);
                        }

                        .premium-customize-btn:before {
                          content: "";
                          position: absolute;
                          top: 0;
                          left: -100%;
                          width: 100%;
                          height: 100%;
                          background: linear-gradient(
                            90deg,
                            transparent,
                            rgba(255, 255, 255, 0.2),
                            transparent
                          );
                          transition: all 0.5s ease;
                          z-index: -1;
                        }

                        .premium-customize-btn:hover:before {
                          left: 100%;
                        }
                      `}</style>

                      {/* <div className="auction-details-card-container2 timerflex">
// ... existing code ...
</code_block_to_apply_changes_from> */}

                      <div className="myflex">
                        <div className="auction-details-card-container2 transpl">
                          <div className="striphead">
                            <h3>Transfer Players From</h3>
                          </div>
                          <div className="strip">
                            <label
                              htmlFor=""
                              style={{ fontSize: "14px", fontWeight: "bold" }}
                            >
                              Copy players from previous auctions
                            </label>
                          </div>
                          <div className="strip">
                            <select
                              className="form-control"
                              type="text"
                              value={pltraid}
                              onChange={(e) => setpltraid(e.target.value)}
                            >
                              <option value="" selected>
                                Select Auction
                              </option>
                              {getpageData2?.responsedata?.list
                                ?.filter(
                                  (auc) => String(auc.aid) !== String(aid)
                                ) // ensures type-safe comparison
                                ?.map((auc) => (
                                  <option value={auc.aid} key={auc.aid}>
                                    {auc.aname}
                                  </option>
                                ))}
                            </select>
                          </div>

                          <div className="">
                            <button
                              className="mydesbtn timerbtn"
                              onClick={pltransfer}
                            >
                              Transfer
                            </button>
                          </div>
                        </div>
                        <div className="auction-details-card-container2 transpl">
                          <div className="striphead">
                            <h3>Transfer Teams From</h3>
                          </div>
                          <div className="strip">
                            <label
                              htmlFor=""
                              style={{ fontSize: "14px", fontWeight: "bold" }}
                            >
                              Copy teams from previous auctions.
                            </label>
                          </div>
                          <div className="strip">
                            <select
                              className="form-control"
                              type="text"
                              value={tmtraid}
                              onChange={(e) => settmtraid(e.target.value)}
                            >
                              <option value="" selected>
                                Select Auction
                              </option>

                              {getpageData2?.responsedata?.list
                                ?.filter(
                                  (auc) => String(auc.aid) !== String(aid)
                                ) // ensures type-safe comparison
                                ?.map((auc) => (
                                  <option value={auc.aid} key={auc.aid}>
                                    {auc.aname}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div>
                            <button
                              className="timerbtn mydesbtn"
                              onClick={tmtransfer}
                            >
                              Transfer
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="myflex"></div>

                      {admin_id && admin_id !== "0" ? (
                        <div className="auction-details-card-container2 customize-box">
                          <div>
                            <div>Transfer Your Teams, Players to Superscore App.</div>
                            <div className="tfdiv">
                              {tfmsg == '0' && <>
                                <span className="transfermsg">First, Register Yourself on SuperScore with same Mobile number.</span>
                                <button className="mydesbtn">Register</button>
                              </>}

                              {tfmsg == '2' && <>
                                <span className="transfermsg">
                                  <FaCheckCircle className="checkusericon" />Data has been Transfered
                                </span>
                              </>}

                              {tfmsg == '3' && <>
                                <span className="transfermsg">
                                  <IoAlertCircleOutline className="checkTouralert" /> Already have Data. Want to OverRide ?
                                </span>
                                <button className="mydesbtn mx-3" onClick={() => transfertoscore(1, trid)}>yes</button>
                                <button className="mydesbtn" onClick={() => settfmsg("")}>Cancel</button>
                              </>}

                              {tfmsg == '4' && <>
                                <div className="transfermsg"><FaCheckCircle className="checkusericon" />  User Succesfully found</div>
                                <div className="transfermsg"><FaCheckCircle className="checkusericon" />  Tournament list found</div>
                                <div className="transfermsg">Select Tournament in which you wanna transfer</div>
                                <div>
                                  <select value={trid} onChange={(e) => settrid(e.target.value)}>
                                    <option value="">Select</option>
                                    {tourList?.map((ele) => (
                                      <option value={ele.tnid}>{ele.title}</option>
                                    ))}
                                  </select>
                                </div>
                                <button className="mydesbtn mx-3" onClick={() => transfertoscore(0, trid)}>Tranfer</button>
                              </>}

                              {tfmsg == '1' && <>
                                <div className="transfermsg"><FaCheckCircle className="checkusericon" />  User Succesfully found</div>
                                <div className="transfermsg">
                                  <IoAlertCircleOutline className="checkTouralert" />Tournament Not yet created.
                                  <span className="createtr" onClick={() => setiscreate(!iscreate)}>Create Tournament</span>
                                </div>

                                {iscreate && <div className="createtrform">
                                  <div className="createtrflex">
                                    <div className="transferInpdiv">
                                      <label>Season</label>
                                      <input type="number" placeholder="Season" value={season} onChange={(e) => setseason(e.target.value)} />
                                    </div>
                                    <div className="transferInpdiv">
                                      <label>city</label>
                                      <input type="text" value={city} placeholder="city" onChange={(e) => setcity(e.target.value)} />
                                    </div>
                                    <div className="transferInpdiv">
                                      <label>From Date</label>
                                      <input type="date" value={from_date} onChange={(e) => setfrom_date(e.target.value)} />
                                    </div>
                                    <div className="transferInpdiv">
                                      <label>To Date</label>
                                      <input type="date" value={to_date} onChange={(e) => setto_date(e.target.value)} />
                                    </div>
                                    <div className="transferInpdiv">
                                      <label>Win point</label>
                                      <input type="number" placeholder="win point" value={win_point} onChange={(e) => setwin_point(e.target.value)} />
                                    </div>
                                    <div className="transferInpdiv">
                                      <label>Tournament Type</label>
                                      <select value={type} onChange={(e) => settype(e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="One-day">One-day</option>
                                        <option value="T-20">T-20</option>
                                        <option value="Box-cricket">Box-cricket</option>
                                        <option value="T-10">T-10</option>
                                      </select>
                                    </div>
                                    <div className="transferInpdiv">
                                      <label>Short Name</label>
                                      <input type="text" placeholder="Short name" value={sname} onChange={(e) => setsname(e.target.value)} />
                                    </div>
                                  </div>

                                  {isallreq && (
                                    <div className="reqfieldsmsg">
                                      <IoAlertCircleOutline className="checkTouralert" />All fields are required
                                    </div>
                                  )}
                                  <div className="tourCreatebtn">
                                    <button className="mydesbtn" onClick={() => transfertoscore(0, 0)}>Create</button>
                                  </div>
                                </div>}
                              </>}
                            </div>
                          </div>
                          <div className="cusdiv">
                            <button className="mydesbtn" onClick={() => transfertoscore(0, 0)}>Let's Go</button>
                          </div>
                        </div>
                      ) : null}


                      {/* <div onClick={() => gotocustom()} className="auction-details-card-container2">
                        <div className="tfteam"><p> Player Self registration Customization</p></div>

                      </div> */}
                    </div>
                  </div>
                ) : (
                  <NotFound data={isActive} />
                )}
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default Auctiondetail;
